/** Toasts that do something: open what was just made, or copy its link. */
import { toast } from "sonner";

export async function copyText(text: string, what = "Link"): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(`${what} copied`);
    return true;
  } catch {
    toast.error("Couldn't reach the clipboard. Copy it from the address bar instead.");
    return false;
  }
}

/**
 * "ENG-12 created" with an Open button and, when a path is given, a Copy link
 * button. `open` runs on the primary action.
 */
export function createdToast(title: string, opts: { open?: () => void; path?: string; description?: string; openLabel?: string } = {}) {
  toast.success(title, {
    description: opts.description,
    action: opts.open ? { label: opts.openLabel ?? "Open", onClick: opts.open } : undefined,
    cancel: opts.path ? { label: "Copy link", onClick: () => void copyText(`${location.origin}${opts.path}`) } : undefined,
  });
}
